import type { Edge, Node } from "@xyflow/react";
import type { IdeaNodeData, DbSchema } from "./types";
import { flowDocumentSchema } from "./flow-document";

const STORAGE_KEY = "idea-scratcher-flow-v1";

export function loadFlow(): { nodes: Node<IdeaNodeData>[]; edges: Edge[] } {
  if (typeof window === "undefined") return { nodes: [], edges: [] };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { nodes: [], edges: [] };
    return flowDocumentSchema.parse(JSON.parse(raw));
  } catch {
    throw new Error(
      "Der gespeicherte Flow konnte nicht geladen werden. Er bleibt im Browser erhalten; exportiere neue Änderungen vor dem Neuladen.",
    );
  }
}

export function saveFlow(nodes: Node<IdeaNodeData>[], edges: Edge[]) {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ version: 2, nodes, edges }),
  );
}

// ─── DB Schema Persistence ────────────────────────────────────────────────────

const DB_SCHEMA_KEY = "idea-scratcher-db-schema-v1";

export function loadDbSchema(): DbSchema {
  if (typeof window === "undefined") return { tables: [] };
  try {
    const raw = localStorage.getItem(DB_SCHEMA_KEY);
    if (!raw) return { tables: [] };
    return JSON.parse(raw) as DbSchema;
  } catch {
    return { tables: [] };
  }
}

export function saveDbSchema(schema: DbSchema) {
  localStorage.setItem(DB_SCHEMA_KEY, JSON.stringify(schema));
}
